module.exports = __webpack_public_path__ + "static/img/pm25.68498a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shitang/pm25.png
// module id = vpaw
// module chunks = 6